// @flow

import * as React from 'react';
import _ from 'lodash';

import { genreHeb, fileLink } from 'common/utils';
import { INFO_POP_UP, PREVIEW_ROUTE, VOTE_POP_UP } from 'client/constants';
import Responsive from 'client/components/common/Responsive';
import { StarsRating, Chart } from 'client/components/common';

import logoTVBee from 'assets/client/images/tvbee-logo-dark.svg';
import beeSprite from 'assets/client/images/bee_sprite.png';

import * as css from './Intro.scss';

type Props = {
	match: RouterMatch,
	item: Item,
	setPopUp: Function,
	saveUserChoice: Function,
	user: {
		isVoted: boolean,
	},
	choice: {},
	updatedUsersRate: number,
	settings: Settings,
};
type State = {
	item: Item,
	isVoited: boolean,
	votedRate: number,
	usersRate: number,
	isPreview: boolean,
	userIsVoted: boolean,
};

class Intro extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			item: props.item,
			isVoited: false,
			votedRate: 0,
			usersRate: _.get(props, 'item.usersRate', 0),
			userIsVoted: _.get(props, 'user.isVoted', false),
			isPreview: this.isPreviewMode,
		};
	}

	componentDidMount() {
		const { item } = this.state;
		const { choice } = this.props;
		const filmId = item.id;

		if (filmId) {
			if (_.keys(choice).includes(filmId)) {
				this.setState({ isVoited: !this.isPreviewMode && true, votedRate: choice[filmId], userIsVoted: true });
			}

			this.setState({ item, usersRate: item.usersRate });
		}
	}

	static getDerivedStateFromProps(nextProps: Props, prevState: State) {
		if (!prevState.isPreview) {
			if (nextProps.updatedUsersRate !== prevState.usersRate && prevState.isVoited) {
				return {
					usersRate: nextProps.updatedUsersRate,
				};
			}

			if (nextProps.item && _.keys(nextProps.choice).includes(nextProps.item.id) && nextProps.user.isVoted) {
				return {
					userIsVoted: true,
					usersRate: nextProps.updatedUsersRate,
					votedRate: nextProps.choice[_.get(nextProps, 'item.id')],
				};
			}
		}
		return null;
	}

	get isPreviewMode() {
		const { match } = this.props;

		return match.path === PREVIEW_ROUTE;
	}

	onRatingClick = async (rating: number) => {
		const { item } = this.state;
		const { saveUserChoice } = this.props;

		if (item) {
			if (!this.isPreviewMode) {
				await saveUserChoice({ id: item.id, rate: Number(rating) });
			} else if (item.usersRate !== undefined && item.votes !== undefined) {
				this.setState({
					usersRate: Math.round((item.usersRate * item.votes + Number(rating)) / (item.votes + 1)),
				});
			}

			this.setState({ isVoited: true });

			setTimeout(() => {
				this.props.setPopUp(INFO_POP_UP);
			}, 1000);
		}
	};

	openVotePopUp = () => {
		setTimeout(() => {
			this.props.setPopUp(VOTE_POP_UP);
		}, 300);
	};

	validateValue = (value: any) => {
		return !!value && value !== 'null';
	};

	render() {
		if (!this.state.item) {
			return null;
		}
		const { settings } = this.props;
		const { item, userIsVoted } = this.state;
		const resoursesTitle = 'איפה רואים?';
		const beforeLogoText = 'דירוג';

		const name = _.get(this.state, 'item.name', '');

		const hasGenres = this.validateValue(_.get(this.state, 'item.seriesData.genre', ''));
		const genres = _.get(this.state, 'item.seriesData.genre', '');

		const hasSeasons = this.validateValue(_.get(this.state, 'item.seriesData.season'));
		const seasons = `${_.get(this.state, 'item.seriesData.season', '')} עונות`;

		const hasAiredEpisodes = this.validateValue(_.get(this.state, 'item.seriesData.airedEpisodes'));
		const airedEpisodes = `${_.get(this.state, 'item.seriesData.airedEpisodes', '')} פרקים`;

		const editorsRate = Number(_.get(this.state, 'item.editorsRate', 0));
		const siteRate = Number(_.get(this.state, 'item.seriesData.siteRating', 0)) * 10; // numbers are like '9.3'
		const resourses = _.get(this.state, 'item.channel', []);
		const starsTitle = 'מה דעתך על הסדרה?';

		let usersRate = siteRate;
		if (+item.votes >= +settings.data.items.minVotes) {
			usersRate = Math.round((+this.state.usersRate * +item.votes + +siteRate) / (+item.votes + 1));
		}

		return (
			<>
				<div className={css.top}>
					<div className={css.logoWrap}>
						<p className={css.beforeLogoText}>{beforeLogoText}</p>
						<img src={logoTVBee} className={css.logoTVBee} alt="logo_tv_bee" />
						<div className={css.beeAnimation} style={{ backgroundImage: `url(${beeSprite})` }} />
					</div>
					<Responsive query={Responsive.DESKTOP}>
						<div className={css.starsWrap}>
							<p className={css.starsTitle}>{starsTitle}</p>
							<StarsRating
								ratingClick={this.onRatingClick}
								disable={this.state.isVoited}
								votedRate={this.state.votedRate}
							/>
						</div>
					</Responsive>
				</div>
				<div className={css.contentContainer}>
					<div className={css.text}>
						<div className={css.genres}>
							<p className={css.title}>{name}</p>
							{hasGenres &&
								_.map(genres, genre => {
									return (
										<span key={`genre-${genre}`} className={css.genre}>
											{genreHeb(genre)}
										</span>
									);
								})}
							<ul>
								{hasSeasons && seasons && <li>{seasons}</li>}
								{hasAiredEpisodes && airedEpisodes && <li>{airedEpisodes}</li>}
							</ul>
						</div>
						{_.size(resourses) > 0 && (
							<div className={css.resourses}>
								<p className={css.title}>{resoursesTitle}</p>
								{_.map(resourses, resourse => {
									return (
										<img
											key={resourse.id}
											src={fileLink(_.get(resourse, 'image'))}
											className={css.resourse}
											alt={resourse.title}
										/>
									);
								})}
							</div>
						)}
						<Responsive query={Responsive.MOBILE}>
							<p className={css.starsTitle}>{starsTitle}</p>
							{userIsVoted ? (
								<React.Fragment>
									<StarsRating
										disable
										ratingClick={this.onRatingClick}
										votedRate={this.state.votedRate}
									/>
								</React.Fragment>
							) : (
								<div className={css.mobileStars} onClick={this.openVotePopUp}>
									<span></span>
									<span></span>
									<span></span>
									<span></span>
									<span></span>
								</div>
							)}
						</Responsive>
					</div>
					<div className={css.charts}>
						<Chart type={Chart.USERS_RAITING} rating={usersRate} />
						<Chart type={Chart.CRITICS_RAITING} rating={editorsRate} />
					</div>
				</div>
			</>
		);
	}
}

export default Intro;
